/**
 * determine if we are executing inside of node, or on a browser.
 * @returns {"NODE"|"BROWSER"}
 */
export const runtime = (): "NODE"|"BROWSER" => {
	return typeof process !== "undefined" && process.versions && process.versions.node
		? "NODE"
		: "BROWSER";
}
